import type { IPayload } from '@adornis/abac/core/types.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import type { UserWithPermissionFields } from '../UserWithPermissionFields.js';

export const MARTINUS_ABAC_PAYLOAD = 'MARTINUS_ABAC_PAYLOAD';

export interface MartinusAbacPayload<A extends string = string> extends IPayload {
  type: typeof MARTINUS_ABAC_PAYLOAD;
  action: A;

  /**
   * The currentUser should be evaluated all the time
   */
  currentUser: Maybe<UserWithPermissionFields>;
}
